"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function assignStyle(domElement, style, component, isPatchOperation) {
    if (!isPatchOperation) {
        // If we have an element from a previous run, remove any old styles that aren't part of the new one
        if (domElement.haiku &&
            domElement.haiku.element &&
            domElement.haiku.element.attributes &&
            domElement.haiku.element.attributes.style) {
            for (var oldStyleKey in domElement.haiku.element.attributes.style) {
                var newStyleValue = style[oldStyleKey];
                if (newStyleValue === null || newStyleValue === undefined) {
                    domElement.style.removeProperty(oldStyleKey);
                }
            }
        }
    }
    for (var key in style) {
        var newProp = style[key];
        var previousProp = domElement.haiku.explicitStyles[key];
        if (previousProp !== newProp) {
            domElement.haiku.explicitStyles[key] = style[key];
            domElement.style[key] = style[key];
        }
    }
    return domElement;
}
exports.default = assignStyle;
//# sourceMappingURL=assignStyle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/renderers/dom/assignStyle.js
// module id = 143
// module chunks = 35783957827783 127651196306611 162898551421021